module.exports = __webpack_public_path__ + "img/pressions_mains_shiatsu-mobile.cb35876e.webp";